






























import {
  defineComponent,
  useContext,
  useFetch,
  ref,
} from "@nuxtjs/composition-api";
import { useUiHelpers } from "~/composables";
import { useTraverseCategory } from "~/modules/catalog/category/helpers/useTraverseCategory";
import { Breadcrumb } from "~/modules/catalog/types";

export default defineComponent({
  setup() {
    const { getCatLink } = useUiHelpers();
    const { localePath } = useContext();

    const { categoryAncestors, isCategoryTreeLoaded, loadCategoryTree } =
      useTraverseCategory();
    const breadcrumbs = ref<Breadcrumb[]>([]);

    const normalizeUrl = (url: string) => {
      return url.replace(/%2F/g, "/");
    };

    useFetch(async () => {
      if (!isCategoryTreeLoaded.value) {
        await loadCategoryTree();
      }

      breadcrumbs.value = categoryAncestors.value.map((category) => ({
        text: category.name,
        link: localePath(getCatLink(category)),
      }));

      const hasHomePage = breadcrumbs.value.some(
        (breadcrumb) => breadcrumb.link === localePath("/")
      );
      if (!hasHomePage) {
        breadcrumbs.value = [
          { link: localePath("/"), text: "Trang chủ" },
          ...breadcrumbs.value,
        ];
      }
    });

    return {
      breadcrumbs,
      normalizeUrl,
    };
  },
});
